import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

export const sendGuestOtp = async (email) => {
  const response = await axios.post(`${BASE_API}/guest-email-verification/send-otp`, { email });
  return response.data;
};

export const verifyGuestOtp = async (email, otp) => {
  const response = await axios.post(`${BASE_API}/guest-email-verification/verify-otp`, { email, otp });
  return response.data;
};

export const resendGuestOtp = async (email) => {
  const response = await axios.post(`${BASE_API}/guest-email-verification/resend-otp`, { email });
  return response.data;
};
